// src/components/sat/PlanProgressHistory.js
//
// Shared "progress detail" block shown inside an expanded plan item across the
// Student Plan detail page, the Edit Plan page, and the tutor SAT Plan Progress
// section. Renders covered/planned hours, completion %, and the full update
// history (tutor · date · hours added · % recorded · session).

import React from "react";
import { itemProgressPct } from "../../utils/sat/satPlanData";

const STATUS_COLOR = { done: "#059669", in_progress: "#f59e0b", todo: "#cbd5e1" };

function fmtDate(ms) {
  if (!ms) return "";
  const d = new Date(ms);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString();
}

export default function PlanProgressHistory({ item, guidance = true }) {
  const pct = itemProgressPct(item);
  const status = pct >= 100 ? "done" : pct > 0 ? "in_progress" : "todo";
  const covered = Number(item.coveredHours) || 0;
  const planned = Number(item.allocatedHours) || 0;
  const history = (Array.isArray(item.progressHistory) ? item.progressHistory : [])
    .slice()
    .sort((a, b) => (b.at || 0) - (a.at || 0));

  return (
    <div style={st.wrap}>
      {guidance && item.guidance && <div style={st.guidance}>{item.guidance}</div>}

      <div style={st.statRow}>
        <span style={st.stat}>
          <strong style={{ color: "#0f172a" }}>{covered}</strong> / {planned}h worked
        </span>
        <span style={st.stat}>
          <strong style={{ color: STATUS_COLOR[status] === "#cbd5e1" ? "#64748b" : STATUS_COLOR[status] }}>{pct}%</strong>{" "}
          complete
        </span>
      </div>
      <div style={st.barOuter}>
        <div style={{ ...st.barInner, width: `${pct}%`, background: STATUS_COLOR[status] }} />
      </div>

      <div style={st.histLabel}>Progress history</div>
      {history.length === 0 ? (
        <div style={st.empty}>No progress recorded yet.</div>
      ) : (
        <div style={st.histList}>
          {history.map((h, i) => (
            <div key={i} style={st.histRow}>
              <span style={st.histTutor}>{h.tutorName || "Tutor"}</span>
              <span style={st.histMeta}>
                {fmtDate(h.at)} · +{Number(h.hoursWorked) || 0}h · {h.progressPct ?? 0}%
                {h.sessionLogId ? " · session" : ""}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const st = {
  wrap: { paddingTop: 4 },
  guidance: { fontSize: 13, color: "#475569", lineHeight: 1.55, marginBottom: 12 },
  statRow: { display: "flex", gap: 18, marginBottom: 8, fontSize: 12.5, color: "#64748b" },
  stat: {},
  barOuter: { height: 10, background: "#e2e8f0", borderRadius: 999, overflow: "hidden", marginBottom: 14 },
  barInner: { height: "100%", borderRadius: 999 },
  histLabel: { fontSize: 10.5, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.06em", color: "#94a3b8", marginBottom: 6 },
  empty: { fontSize: 12.5, color: "#94a3b8" },
  histList: { display: "flex", flexDirection: "column", gap: 6 },
  histRow: { display: "flex", justifyContent: "space-between", gap: 12, fontSize: 12.5, color: "#475569", alignItems: "baseline" },
  histTutor: { fontWeight: 700, color: "#334155" },
  histMeta: { color: "#94a3b8", textAlign: "right" },
};
